/**
 * This is the JS for the bar that appears at the bottom of product pages
 */
export default function stickyAddToCart() {
    let heroSection = document.querySelector('.section-producthero')
    let stickyATC = document.querySelector('.sticky-add-to-cart')
    let footer = document.querySelector('.site-footer')

    if (!heroSection || !stickyATC) {
        return
    }

    function checkScrollPosition() {
        // Check if the scroll position is beyond the hero section
        if (
            window.scrollY >= heroSection.offsetHeight / 2 &&
            window.scrollY < footer.offsetTop - window.innerHeight
        ) {
            // Add the class to the target element
            stickyATC.classList.add('in')
        } else {
            // Remove the class from the target element
            stickyATC.classList.remove('in')
        }
    }

    window.addEventListener('scroll', checkScrollPosition)
}
